import { Environment } from 'fym-common/src/config/types';
import { ArtistPortalAuthKind } from 'fym-shared/src/smartlinks/artistPortals';
import { config } from '../../../config/config';

/**
 * Whether the connect flow is offered at all.
 *
 * There is no OAuth behind it yet: pressing **Connect** files a request a human
 * later moves on. That is honest work in development and a promise we cannot
 * keep in production, so production is shown only the path that works today —
 * paste the artist profile url, claim the releases by hand. Nothing else on the
 * screen changes: the cards, the catalog and every claim work either way.
 *
 * To preview the production view in development, set
 * `localStorage.catalogConnectPreviewProduction = '1'` and reload; remove the
 * key to get the connect flow back. Production ignores the key: the gate below
 * is already false there.
 */
const isProductionPreviewForced: boolean = (() => {
  try {
    return typeof window !== 'undefined' && window.localStorage?.getItem('catalogConnectPreviewProduction') === '1';
  } catch {
    return false;
  }
})();

export const isCatalogConnectFlowEnabled: boolean =
  config.environment !== Environment.production && !isProductionPreviewForced;

/**
 * Whether to offer Connect on one service's card.
 *
 * A service we hold a provider for is offered on every environment: the button
 * signs the artist in and reads their real numbers, which is a promise we can
 * keep. Everything else keeps the old gate, so production never sees a button
 * that only files a request.
 */
export function isServiceConnectOffered(connection: {
  connectAvailable: boolean;
  authKind: ArtistPortalAuthKind | null;
}): boolean {
  if (connection.connectAvailable && connection.authKind !== null) {
    return true;
  }
  return isCatalogConnectFlowEnabled;
}
